import * as React from 'react'
import Box from '@mui/material/Box'
import { isSameDay } from 'date-fns'
import type { CalendarEvent } from '../../typings'
import { HourGutter } from './HourGutter'
import { TimedEventsColumn } from './TimedEventsColumn'
import { GRID_COLUMNS } from './weekGeometry'

type Props = {
  days: Date[]
  timedByDay: CalendarEvent[][]
  today: Date
  onShowDay?: (day: Date) => void
}

// A week column is ~1/7 of the width; beyond four lanes tiles become slivers.
const WEEK_MAX_LANES = 4

/** Body row — hour gutter + 7 lane-packed day columns of timed tiles. */
export function WeekBodyRow({ days, timedByDay, today, onShowDay }: Props) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: GRID_COLUMNS }}>
      <HourGutter />

      {days.map((day, i) => (
        <TimedEventsColumn
          key={day.toISOString()}
          testId="week-day-column"
          day={day}
          events={timedByDay[i]}
          highlightToday={isSameDay(day, today)}
          maxLanes={WEEK_MAX_LANES}
          onShowMore={onShowDay}
        />
      ))}
    </Box>
  )
}
